
// menu dropdown hover custom js
document.addEventListener("DOMContentLoaded", function () {
  var menuItems = document.querySelectorAll(".hover-menu");
  menuItems.forEach(function (menuItem) {
 
    menuItem.addEventListener("mouseover", function () {
      menuItem.setAttribute("open", "");
    });

    menuItem.addEventListener("mouseout", function () {
      menuItem.removeAttribute("open"); 
    });
  });
});


let helloShown = false;
window.addEventListener('scroll', function () {
  const scrollTop = window.scrollY;
  const docHeight = document.body.scrollHeight - window.innerHeight;
  const scrollPercent = (scrollTop / docHeight) * 100;
  const headerclass = document.querySelector('.section-header');

  if (!helloShown && scrollPercent > 3) {
    helloShown = true;
    if (headerclass) {
      headerclass.classList.add('headerclass-active');
    }
  }

  if (scrollPercent <= 5) {
    helloShown = false;
    if (headerclass) {
      headerclass.classList.remove('headerclass-active');
    }
  }
});




// // main-product-size-btn.js
// document.addEventListener("DOMContentLoaded", function () {
//   const openBtn = document.getElementById("ujp-open-btn");
//   const popup = document.getElementById("ujp-popup");
//   const closeBtn = document.getElementById("ujp-close-btn");

//   // Open popup when button is clicked
//   openBtn.addEventListener("click", () => {
//     popup.style.display = "block";
//   });

//   // Close popup when button is clicked
//   closeBtn.addEventListener("click", () => {
//     popup.style.display = "none";
//   });

//   // Close popup if clicked outside the content
//   window.addEventListener("click", (event) => {
//     if (event.target === popup) {
//       popup.style.display = "none";
//     }
//   });
// });



        document.addEventListener('DOMContentLoaded', function () {
         
          const popupLink = document.querySelector('.cstm-size-btn');
          const popup = document.querySelector('#ujp-popup');
          const closeBtn = popup.querySelector('.ujp-close-btn');
   
          popupLink.addEventListener('click', function (e) {
            popup.style.display = 'block';
          });
     
          closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            popup.style.display = 'none';
          });
     
          window.addEventListener('click', function(e) {
            if (e.target === popup) {
              popup.style.display = 'none';
            }
          });
        });
   
